import React, { useState, useRef, useEffect } from 'react';
import ChevronDownIcon from './ChevronDownIcon';

/**
 * Reusable filter dropdown.
 * @param {string} label - Button label
 * @param {Array} options - Array of option strings
 * @param {string} defaultValue - Default selected option
 */
const FilterSelect = ({ label, options = [], defaultValue }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState(defaultValue || null);
  const ref = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, []);

  const handleOptionClick = (opt) => {
    setSelected(opt);
    setIsOpen(false);
  };

  return (
    <div className="filter-select" ref={ref}>
      <button
        className={`filter-select__btn${selected ? ' filter-select__btn--active' : ''}`}
        onClick={(e) => {
          setIsOpen((prev) => !prev);
        }}
      >
        <span className="filter-select__label">{selected || label}</span>{' '}
        <ChevronDownIcon />
      </button>
      <div className={`filter-select__dropdown${isOpen ? ' is-open' : ''}`}>
        {options.map((opt) => (
          <div
            className={`filter-select__option${
              selected === opt ? ' filter-select__option--active' : ''
            }`}
            key={opt}
            onClick={() => handleOptionClick(opt)}
          >
            {opt}
          </div>
        ))}
      </div>
    </div>
  );
};

export default FilterSelect;
